(function () {
  var REGULAR_HANDLE = 'heropack';
  var MAX_HANDLE = 'heropack-max';
  var MAX_FALLBACK_PRICE = 65900;
  var STYLE_ID = 'hp-mobile-cart-upsell-style-v13';
  var refreshTimer = null;
  var observerStarted = false;

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
  }

  function formatMoney(cents) {
    cents = Number(cents || 0);
    return '₪' + (cents / 100).toFixed(2);
  }

  function formatMoneyClean(cents) {
    cents = Number(cents || 0);
    var shekels = cents / 100;
    if (Math.round(shekels) === shekels) {
      return '₪' + String(Math.round(shekels));
    }
    return '₪' + shekels.toFixed(2);
  }

  function removeOldStyles() {
    document.querySelectorAll(
      '#hp-mobile-cart-upsell-style-v2, #hp-mobile-cart-upsell-style-v3, #hp-mobile-cart-upsell-style-v4, #hp-mobile-cart-upsell-style-v5, #hp-mobile-cart-upsell-style-v6, #hp-mobile-cart-upsell-style-v7, #hp-mobile-cart-upsell-style-v8, #hp-mobile-cart-upsell-style-v9, #hp-mobile-cart-upsell-style-v10, #hp-mobile-cart-upsell-style-v11, #hp-mobile-cart-upsell-style-v12, #hp-mobile-cart-upsell-style-v13'
    ).forEach(function (el) {
      el.remove();
    });
  }

  function injectStyle() {
    removeOldStyles();

    if (document.getElementById(STYLE_ID)) return;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
@media screen and (max-width: 749px){

  /*
    IMPORTANT:
    This file does NOT disable pointer-events on the cart drawer.
    That was the reason the drawer stopped closing and buttons stopped responding.
  */

  html body cart-drawer.drawer.active .drawer__inner,
  html body cart-drawer.active .drawer__inner,
  html body #CartDrawer.active .drawer__inner,
  html body .cart-drawer.active .drawer__inner{
    position: fixed !important;
    top: auto !important;
    right: 0 !important;
    left: 0 !important;
    bottom: 0 !important;

    width: 100vw !important;
    max-width: 100vw !important;
    min-width: 0 !important;

    height: auto !important;
    min-height: 0 !important;
    max-height: 88dvh !important;

    padding: 0 !important;
    margin: 0 !important;

    background: #ffffff !important;
    border-radius: 24px 24px 0 0 !important;
    /* v13 critical fix: make the bottom drawer itself scrollable on real phones */
    overflow-y: auto !important;
    overflow-x: hidden !important;
    -webkit-overflow-scrolling: touch !important;
    overscroll-behavior: contain !important;
    touch-action: pan-y !important;

    box-sizing: border-box !important;

    display: block !important;

    box-shadow: 0 -18px 45px rgba(0,0,0,.22) !important;
    pointer-events: auto !important;
    transform: translateY(0) !important;
  }

  html body cart-drawer .drawer__overlay,
  html body #CartDrawer .drawer__overlay,
  html body .cart-drawer .drawer__overlay{
    background: rgba(0,0,0,.42) !important;
  }

  html body cart-drawer .drawer__header,
  html body #CartDrawer .drawer__header,
  html body .cart-drawer .drawer__header{
    position: relative !important;
    width: 100% !important;
    height: 56px !important;
    min-height: 56px !important;
    padding: 0 54px !important;
    margin: 0 !important;

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    background: #ffffff !important;
    border-bottom: 1px solid rgba(14,27,77,.10) !important;
    box-sizing: border-box !important;
    flex: 0 0 56px !important;
  }

  html body cart-drawer .drawer__heading,
  html body #CartDrawer .drawer__heading,
  html body .cart-drawer .drawer__heading{
    margin: 0 !important;
    padding: 0 !important;
    color: #0E1B4D !important;
    font-size: 21px !important;
    line-height: 1.2 !important;
    font-weight: 900 !important;
    text-align: center !important;
  }

  html body cart-drawer .drawer__header .drawer__close,
  html body #CartDrawer .drawer__header .drawer__close,
  html body .cart-drawer .drawer__header .drawer__close{
    position: absolute !important;
    left: 14px !important;
    right: auto !important;
    top: 50% !important;
    transform: translateY(-50%) !important;

    width: 40px !important;
    height: 40px !important;
    min-width: 40px !important;
    min-height: 40px !important;

    padding: 0 !important;
    margin: 0 !important;
    border: 0 !important;
    background: transparent !important;
    color: #0E1B4D !important;

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    pointer-events: auto !important;
    z-index: 20 !important;
  }

  html body cart-drawer .drawer__contents,
  html body #CartDrawer .drawer__contents,
  html body .cart-drawer .drawer__contents,
  html body cart-drawer form,
  html body #CartDrawer form,
  html body .cart-drawer form{
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;

    display: block !important;
    flex: none !important;

    overflow: visible !important;
  }

  html body cart-drawer cart-drawer-items,
  html body #CartDrawer cart-drawer-items,
  html body .cart-drawer cart-drawer-items{
    height: auto !important;
    min-height: 112px !important;
    max-height: none !important;

    padding: 12px 16px 8px 16px !important;
    margin: 0 !important;

    overflow: visible !important;
    box-sizing: border-box !important;
    flex: none !important;
  }

  html body cart-drawer .cart-item,
  html body #CartDrawer .cart-item,
  html body .cart-drawer .cart-item{
    min-height: 0 !important;
    padding-top: 4px !important;
    padding-bottom: 8px !important;
  }

  html body cart-drawer .drawer__footer,
  html body #CartDrawer .drawer__footer,
  html body .cart-drawer .drawer__footer,
  html body cart-drawer .cart-drawer__footer,
  html body #CartDrawer .cart-drawer__footer,
  html body .cart-drawer .cart-drawer__footer{
    position: static !important;
    margin-top: 0 !important;
    padding: 10px 18px 18px 18px !important;

    background: #ffffff !important;
    border-top: 1px solid rgba(14,27,77,.10) !important;

    box-sizing: border-box !important;
    flex: 0 0 auto !important;
    pointer-events: auto !important;
  }

  .hp-cart-max-upsell{
    width: calc(100% - 32px) !important;
    margin: 0 16px 12px 16px !important;
    padding: 14px 14px 13px 14px !important;

    direction: rtl !important;
    text-align: center !important;

    border-radius: 18px !important;
    background:
      radial-gradient(circle at 15% 15%, rgba(255,214,94,.25), transparent 28%),
      linear-gradient(135deg, #0E1B4D 0%, #172C70 100%) !important;

    border: 1px solid rgba(255,221,120,.35) !important;
    box-shadow: 0 10px 24px rgba(14,27,77,.20) !important;
    box-sizing: border-box !important;
    pointer-events: auto !important;
  }

  .hp-cart-max-upsell__badge{
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;

    margin: 0 auto 7px auto !important;
    padding: 4px 10px !important;

    border-radius: 999px !important;
    background: rgba(255,221,120,.16) !important;
    border: 1px solid rgba(255,221,120,.42) !important;

    color: #FFE184 !important;
    font-size: 11px !important;
    font-weight: 900 !important;
    line-height: 1.2 !important;
  }

  .hp-cart-max-upsell__title{
    margin: 0 0 5px 0 !important;
    color: #ffffff !important;
    font-size: 18px !important;
    line-height: 1.18 !important;
    font-weight: 950 !important;
  }

  .hp-cart-max-upsell__text{
    margin: 0 0 9px 0 !important;
    color: rgba(255,255,255,.88) !important;
    font-size: 13px !important;
    line-height: 1.35 !important;
    font-weight: 700 !important;
  }

  .hp-cart-max-upsell__points{
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr !important;
    gap: 6px !important;
    margin: 0 0 9px 0 !important;
  }

  .hp-cart-max-upsell__point{
    padding: 6px 5px !important;
    border-radius: 11px !important;
    background: rgba(255,255,255,.09) !important;
    border: 1px solid rgba(255,255,255,.13) !important;

    color: #ffffff !important;
    font-size: 11px !important;
    line-height: 1.2 !important;
    font-weight: 800 !important;
  }

  .hp-cart-max-upsell__point span{
    color: #FFD85C !important;
    font-weight: 950 !important;
    margin-left: 3px !important;
  }

  .hp-cart-max-upsell__price-strip{
    width: 100% !important;
    margin: 0 0 11px 0 !important;
    padding: 9px 10px !important;

    display: grid !important;
    grid-template-columns: 1fr auto 1fr !important;
    align-items: center !important;
    gap: 7px !important;

    border-radius: 13px !important;
    background: rgba(255,255,255,.08) !important;
    border: 1px solid rgba(255,255,255,.15) !important;

    color: #ffffff !important;
    box-sizing: border-box !important;
  }

  .hp-cart-max-upsell__price-cell{
    display: flex !important;
    flex-direction: column !important;
    gap: 3px !important;
    align-items: center !important;
    justify-content: center !important;
    min-width: 0 !important;
  }

  .hp-cart-max-upsell__price-label{
    color: rgba(255,255,255,.80) !important;
    font-size: 11px !important;
    line-height: 1.15 !important;
    font-weight: 900 !important;
    white-space: nowrap !important;
  }

  .hp-cart-max-upsell__price-value{
    color: #FFE184 !important;
    font-size: 15px !important;
    line-height: 1.1 !important;
    font-weight: 950 !important;
    white-space: nowrap !important;
  }

  .hp-cart-max-upsell__price-arrow{
    color: #FFE184 !important;
    font-size: 26px !important;
    line-height: 1 !important;
    font-weight: 950 !important;
    text-shadow: 0 2px 10px rgba(255,224,130,.35) !important;
    transform: translateY(2px) !important;
  }

  .hp-cart-max-upsell__delta{
    margin: 0 0 10px 0 !important;
    color: #ffffff !important;
    font-size: 13px !important;
    line-height: 1.25 !important;
    font-weight: 900 !important;
  }

  .hp-cart-max-upsell__delta strong{
    color: #FFE184 !important;
    font-size: 15px !important;
    font-weight: 950 !important;
    white-space: nowrap !important;
  }

  .hp-cart-max-upsell__details{
    width: 100% !important;
    display: grid !important;
    gap: 7px !important;
    margin: 0 0 11px 0 !important;
  }

  .hp-cart-max-upsell__details details{
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    border-radius: 12px !important;
    overflow: hidden !important;
    background: rgba(255,255,255,.08) !important;
    border: 1px solid rgba(255,255,255,.14) !important;
  }

  .hp-cart-max-upsell__details summary{
    list-style: none !important;
    min-height: 38px !important;
    padding: 10px 38px 10px 12px !important;
    margin: 0 !important;
    cursor: pointer !important;
    position: relative !important;
    direction: rtl !important;
    text-align: right !important;

    color: #ffffff !important;
    font-size: 12.5px !important;
    line-height: 1.25 !important;
    font-weight: 900 !important;

    display: flex !important;
    align-items: center !important;
  }

  .hp-cart-max-upsell__details summary::-webkit-details-marker{
    display: none !important;
  }

  .hp-cart-max-upsell__details summary::before{
    content: "+" !important;
    position: absolute !important;
    right: 14px !important;
    top: 50% !important;
    transform: translateY(-50%) !important;
    color: #FFE184 !important;
    font-size: 16px !important;
    font-weight: 950 !important;
    line-height: 1 !important;
  }

  .hp-cart-max-upsell__details details[open] summary::before{
    content: "−" !important;
  }

  .hp-cart-max-upsell__details-body{
    padding: 0 14px 10px 14px !important;
    margin: 0 !important;
    color: rgba(255,255,255,.88) !important;
    font-size: 12px !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    text-align: right !important;
    direction: rtl !important;
  }

  .hp-cart-max-upsell__details-body ul{
    margin: 0 !important;
    padding: 0 !important;
    list-style: none !important;
    display: grid !important;
    gap: 4px !important;
  }

  .hp-cart-max-upsell__details-body li{
    position: relative !important;
    padding-right: 17px !important;
    color: rgba(255,255,255,.90) !important;
    font-size: 11.8px !important;
    line-height: 1.34 !important;
    font-weight: 700 !important;
  }

  .hp-cart-max-upsell__details-body li::before{
    content: "✓" !important;
    position: absolute !important;
    right: 0 !important;
    top: 0 !important;
    color: #FFE184 !important;
    font-size: 11px !important;
    font-weight: 950 !important;
  }

  .hp-cart-max-upsell__details-note{
    margin: 0 !important;
    color: rgba(255,255,255,.88) !important;
    font-size: 12px !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
  }

  .hp-cart-max-upsell__section-link{
    width: 100% !important;
    min-height: 38px !important;
    margin: 8px 0 0 0 !important;
    padding: 9px 12px !important;

    border-radius: 999px !important;
    border: 1px solid rgba(255,224,130,.50) !important;
    background: rgba(255,224,130,.12) !important;
    color: #FFE184 !important;

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    font-size: 12px !important;
    line-height: 1.2 !important;
    font-weight: 950 !important;
    text-decoration: none !important;
    cursor: pointer !important;
    box-sizing: border-box !important;
  }

  .hp-cart-max-upsell__section-link:active{
    transform: scale(.98) !important;
  }

  .hp-return-to-cart-btn{
    position: fixed !important;
    left: 50% !important;
    right: auto !important;
    bottom: 84px !important;
    transform: translateX(-50%) translateY(18px) !important;
    z-index: 2147483646 !important;

    width: min(280px, calc(100vw - 126px)) !important;
    min-height: 46px !important;
    padding: 0 18px !important;

    border: 0 !important;
    border-radius: 999px !important;
    background: linear-gradient(180deg, #FFE082 0%, #F2C84B 100%) !important;
    color: #0E1B4D !important;

    font-family: Assistant, Arial, sans-serif !important;
    font-size: 15px !important;
    line-height: 1.15 !important;
    font-weight: 950 !important;
    text-align: center !important;

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    gap: 7px !important;

    box-shadow: 0 12px 28px rgba(0,0,0,.22) !important;
    opacity: 0 !important;
    visibility: hidden !important;
    pointer-events: none !important;
    cursor: pointer !important;
    transition: opacity .2s ease, transform .2s ease, visibility .2s ease !important;
  }

  .hp-return-to-cart-btn.is-visible{
    opacity: 1 !important;
    visibility: visible !important;
    pointer-events: auto !important;
    transform: translateX(-50%) translateY(0) !important;
  }

  .hp-return-to-cart-btn::before{
    content: "←" !important;
    font-size: 18px !important;
    line-height: 1 !important;
    font-weight: 950 !important;
  }

  .hp-cart-max-upsell__btn{
    width: 100% !important;
    min-height: 44px !important;

    border: 0 !important;
    border-radius: 999px !important;

    background: linear-gradient(180deg, #FFE082 0%, #F2C84B 100%) !important;
    color: #0E1B4D !important;

    font-size: 14px !important;
    line-height: 1.2 !important;
    font-weight: 950 !important;

    display: flex !important;
    align-items: center !important;
    justify-content: center !important;

    cursor: pointer !important;
    box-shadow: 0 9px 18px rgba(0,0,0,.20) !important;
    pointer-events: auto !important;
  }

  .hp-cart-max-upsell__btn[disabled]{
    opacity: .72 !important;
    cursor: wait !important;
  }

  .hp-cart-max-upsell__small{
    margin: 8px 0 0 0 !important;
    color: rgba(255,255,255,.78) !important;
    font-size: 11px !important;
    line-height: 1.25 !important;
    font-weight: 700 !important;
  }

  html body cart-drawer .totals,
  html body #CartDrawer .totals,
  html body .cart-drawer .totals{
    margin-top: 0 !important;
    margin-bottom: 10px !important;
  }

  html body cart-drawer .cart__checkout-button,
  html body #CartDrawer .cart__checkout-button,
  html body .cart-drawer .cart__checkout-button{
    min-height: 52px !important;
    height: 52px !important;
    border-radius: 999px !important;
    pointer-events: auto !important;
  }
}
`;
    document.head.appendChild(style);
  }

  function getCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin'
    }).then(function (res) {
      return res.json();
    });
  }

  function getMaxProduct() {
    return fetch('/products/' + MAX_HANDLE + '.js', {
      credentials: 'same-origin'
    }).then(function (res) {
      if (!res.ok) throw new Error('MAX product not found');
      return res.json();
    });
  }

  function getMaxVariant() {
    return getMaxProduct().then(function (product) {
      if (!product.variants || !product.variants.length) {
        throw new Error('MAX variant not found');
      }

      var available = product.variants.find(function (v) {
        return v.available;
      });

      return available || product.variants[0];
    });
  }

  function findRegularItem(cart) {
    return (cart.items || []).find(function (item) {
      var handle = item.handle || '';
      var title = item.product_title || item.title || '';

      return handle === REGULAR_HANDLE ||
        (title.indexOf('HeroPack') !== -1 && title.indexOf('MAX') === -1);
    });
  }

  function hasMaxItem(cart) {
    return (cart.items || []).some(function (item) {
      var handle = item.handle || '';
      var title = item.product_title || item.title || '';

      return handle === MAX_HANDLE || title.indexOf('MAX') !== -1;
    });
  }

  function changeCartLine(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    }).then(function (res) {
      return res.json();
    });
  }

  function addMaxToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity || 1
      })
    }).then(function (res) {
      return res.json();
    });
  }

  function getDrawer() {
    return document.querySelector('cart-drawer, #CartDrawer, .cart-drawer');
  }

  function forceCloseDrawer(drawer) {
    drawer = drawer || getDrawer();
    if (!drawer) return;

    try {
      if (typeof drawer.close === 'function') {
        drawer.close();
      }
    } catch (e) {}

    window.setTimeout(function () {
      drawer.classList.remove('active', 'animate', 'menu-opening');
      drawer.removeAttribute('open');

      var details = drawer.closest('details');
      if (details) details.removeAttribute('open');

      document.body.classList.remove('overflow-hidden', 'hp-cart-drawer-is-open');
      document.documentElement.classList.remove('overflow-hidden');
    }, 80);
  }

  function bindCloseFallback() {
    var drawer = getDrawer();
    if (!drawer || drawer.dataset.hpCloseFallbackBound === '1') return;

    drawer.dataset.hpCloseFallbackBound = '1';

    drawer.addEventListener('click', function (event) {
      var closeBtn = event.target.closest('.drawer__close');
      var overlay = event.target.closest('.drawer__overlay');

      if (!closeBtn && !overlay) return;

      window.setTimeout(function () {
        forceCloseDrawer(drawer);
      }, 30);
    }, true);
  }

  function hpNormText(el) {
    return (el && el.textContent ? el.textContent : '')
      .replace(/\s+/g, ' ')
      .replace(/[־–—]/g, '-')
      .trim();
  }

  function findMaxDetailsHeading() {
    var headingSelectors = [
      '#MainContent h1',
      '#MainContent h2',
      '#MainContent h3',
      '#MainContent .title',
      '#MainContent .collapsible-content__heading',
      '#MainContent [class*="heading"]'
    ].join(',');

    var headings = Array.prototype.slice.call(document.querySelectorAll(headingSelectors));
    var exact = null;

    headings.some(function (h) {
      var t = hpNormText(h);

      var hasMax =
        t.indexOf('HeroPack MAX') !== -1 ||
        t.indexOf('הירופאק מקס') !== -1 ||
        t.indexOf('אירופק מקס') !== -1;

      var isRealMaxHeading =
        hasMax &&
        (
          t.indexOf('מה כולל') !== -1 ||
          t.indexOf('תוספת הפריטים') !== -1 ||
          t.indexOf('תוספות') !== -1
        );

      var isUpgradeBanner =
        t.indexOf('רוצים לשדרג') !== -1 ||
        t.indexOf('שדרגו ל-HeroPack MAX') !== -1 ||
        t.indexOf('שדרגו ל־HeroPack MAX') !== -1 ||
        t.indexOf('רגע לפני התשלום') !== -1;

      if (isRealMaxHeading && !isUpgradeBanner) {
        exact = h;
        return true;
      }

      return false;
    });

    return exact;
  }

  function findMaxDetailsSection() {
    var heading = findMaxDetailsHeading();
    if (heading) return heading;

    var sections = Array.prototype.slice.call(document.querySelectorAll('#MainContent .shopify-section, #MainContent section'));
    var best = null;

    sections.some(function (section) {
      var text = hpNormText(section);

      var isUpgradeBanner =
        text.indexOf('רוצים לשדרג') !== -1 ||
        text.indexOf('שדרגו ל-HeroPack MAX') !== -1 ||
        text.indexOf('שדרגו ל־HeroPack MAX') !== -1 ||
        text.indexOf('רגע לפני התשלום') !== -1;

      var isRealMaxDetails =
        text.indexOf('HeroPack MAX') !== -1 &&
        (
          text.indexOf('תוספת הפריטים') !== -1 ||
          text.indexOf('מה כולל') !== -1 ||
          text.indexOf('20 פריטים') !== -1 ||
          text.indexOf('כ־20 פריטים') !== -1 ||
          text.indexOf('כ-20 פריטים') !== -1
        );

      if (isRealMaxDetails && !isUpgradeBanner) {
        best = section;
        return true;
      }

      return false;
    });

    return best;
  }

  function scrollToMaxDetailsSection() {
    var heading = findMaxDetailsHeading();
    var target = heading || findMaxDetailsSection();

    if (!target) {
      window.location.hash = 'hp-max-details-section';
      return;
    }

    target.id = target.id || 'hp-max-details-section';

    /*
      Mobile fix:
      The blue MAX upgrade banner sits above the full MAX details.
      Scroll to the actual "מה כולל HeroPack MAX" heading so it appears at the top.
    */
    var y = target.getBoundingClientRect().top + window.pageYOffset - 10;
    if (y < 0) y = 0;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
  }

  function getCartButtonTrigger() {
    return document.querySelector(
      '#cart-icon-bubble, .header__icon--cart, a[href="/cart"], a[href*="/cart"]'
    );
  }

  function openCartDrawer() {
    var drawer = getDrawer();

    if (!drawer) {
      var trigger = getCartButtonTrigger();
      if (trigger) trigger.click();
      return;
    }

    try {
      if (typeof drawer.open === 'function') {
        drawer.open(getCartButtonTrigger());
      }
    } catch (e) {}

    drawer.classList.add('active', 'animate');

    document.body.classList.add('overflow-hidden', 'hp-cart-drawer-is-open');
    document.documentElement.classList.add('overflow-hidden');

    var details = drawer.closest('details');
    if (details) details.setAttribute('open', '');

    var overlay = drawer.querySelector('.drawer__overlay');
    if (overlay) overlay.style.pointerEvents = 'auto';

    window.setTimeout(function () {
      refreshUpsell();
    }, 250);
  }

  function hideReturnToCartButton() {
    var btn = document.getElementById('hpReturnToCartBtn');
    if (btn) btn.classList.remove('is-visible');
  }

  function ensureReturnToCartButton() {
    var btn = document.getElementById('hpReturnToCartBtn');

    if (!btn) {
      btn = document.createElement('button');
      btn.id = 'hpReturnToCartBtn';
      btn.type = 'button';
      btn.className = 'hp-return-to-cart-btn';
      btn.textContent = 'חזרה לעגלה';
      btn.setAttribute('aria-label', 'חזרה לעגלה');

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        hideReturnToCartButton();
        openCartDrawer();
      }, true);

      document.body.appendChild(btn);
    }

    return btn;
  }

  function showReturnToCartButton() {
    if (!isMobile()) return;

    var btn = ensureReturnToCartButton();
    btn.classList.add('is-visible');

    window.clearTimeout(window.hpReturnToCartTimer);
    window.hpReturnToCartTimer = window.setTimeout(function () {
      hideReturnToCartButton();
    }, 45000);
  }

  function buildUpsellHtml(regular, cart, maxVariant) {
    var qty = regular && regular.quantity ? regular.quantity : 1;

    var regularLinePrice = regular && typeof regular.final_line_price !== 'undefined'
      ? Number(regular.final_line_price)
      : Number(cart.total_price || 0);

    var maxUnitPrice = maxVariant && typeof maxVariant.price !== 'undefined'
      ? Number(maxVariant.price)
      : MAX_FALLBACK_PRICE;

    var maxTotal = maxUnitPrice * qty;
    var upgradeDelta = maxTotal - regularLinePrice;

    if (!isFinite(upgradeDelta) || upgradeDelta <= 0) {
      upgradeDelta = Math.max(0, MAX_FALLBACK_PRICE * qty - regularLinePrice);
    }

    return {
      signature: [
        'v13_mobile_drawer_scroll_fix',
        regular.key || '',
        qty,
        regularLinePrice,
        maxUnitPrice,
        maxTotal,
        upgradeDelta
      ].join('|'),

      html: `
        <div class="hp-cart-max-upsell__badge">רגע לפני התשלום</div>

        <div class="hp-cart-max-upsell__title">רוצים לשדרג ל־HeroPack MAX?</div>

        <div class="hp-cart-max-upsell__text">
          מ־12 פריטים לכ־20 פריטים: יותר ציוד לנסיעות, טיסות, סופי שבוע, אימונים ויום־יום מסודר יותר.
        </div>

        <div class="hp-cart-max-upsell__points">
          <div class="hp-cart-max-upsell__point"><span>✓</span>כולל את HeroPack</div>
          <div class="hp-cart-max-upsell__point"><span>✓</span>תוספות פרקטיות</div>
          <div class="hp-cart-max-upsell__point"><span>✓</span>מתנה מרשימה יותר</div>
        </div>

        <div class="hp-cart-max-upsell__price-strip" aria-label="השוואת מחיר השדרוג">
          <div class="hp-cart-max-upsell__price-cell">
            <span class="hp-cart-max-upsell__price-label">HeroPack</span>
            <span class="hp-cart-max-upsell__price-value">${formatMoneyClean(regularLinePrice)}</span>
          </div>

          <div class="hp-cart-max-upsell__price-arrow">⬅</div>

          <div class="hp-cart-max-upsell__price-cell">
            <span class="hp-cart-max-upsell__price-label">HeroPack MAX</span>
            <span class="hp-cart-max-upsell__price-value">${formatMoneyClean(maxTotal)}</span>
          </div>
        </div>

        <div class="hp-cart-max-upsell__delta">
          תוספת לשדרוג: <strong>${formatMoneyClean(upgradeDelta)}</strong>
        </div>

        <div class="hp-cart-max-upsell__details">
          <details open>
            <summary>מה מקבלים ב־HeroPack MAX?</summary>
            <div class="hp-cart-max-upsell__details-body">
              <ul>
                <li>שדרוג מכ־12 פריטים לכ־20 פריטים בערכה אחת</li>
                <li>כולל את HeroPack הרגיל + תוספות שימושיות לדרך</li>
                <li>יותר מתאים לנסיעות, טיסות, סופי שבוע ואימונים</li>
              </ul>
              <a href="#hp-max-details-section" class="hp-cart-max-upsell__section-link">
                ראו את כל תוספות MAX
              </a>
            </div>
          </details>

          <details>
            <summary>למה זה שדרוג משתלם?</summary>
            <div class="hp-cart-max-upsell__details-body">
              <p class="hp-cart-max-upsell__details-note">
                במקום לעצור בערכת הבסיס, MAX מוסיף עוד שכבת שימושים פרקטית: ציוד לדרך, לנסיעות, לטיסות, לאימונים ולסופי שבוע מחוץ לבית.
              </p>
            </div>
          </details>

          <details>
            <summary>האם זה מחליף את הערכה הרגילה?</summary>
            <div class="hp-cart-max-upsell__details-body">
              <p class="hp-cart-max-upsell__details-note">
                כן. בלחיצה על השדרוג, HeroPack הרגיל מוחלף ב־HeroPack MAX והמערכת מעבירה אותך ישר לתשלום.
              </p>
            </div>
          </details>
        </div>

        <button type="button" class="hp-cart-max-upsell__btn">
          שדרגו ל־HeroPack MAX
        </button>

        <div class="hp-cart-max-upsell__small">
          הסכום למטה יתעדכן אחרי לחיצה על השדרוג
        </div>
      `
    };
  }

  function upgradeToMax(button) {
    if (!button || button.dataset.loading === '1') return;

    button.dataset.loading = '1';
    button.disabled = true;
    button.textContent = 'משדרגים ל־HeroPack MAX...';

    var regularItem;
    var qty = 1;

    getCart()
      .then(function (cart) {
        regularItem = findRegularItem(cart);
        if (regularItem && regularItem.quantity) qty = regularItem.quantity;
        return getMaxVariant();
      })
      .then(function (variant) {
        if (regularItem && regularItem.key) {
          return changeCartLine(regularItem.key, 0).then(function () {
            return addMaxToCart(variant.id, qty);
          });
        }

        return addMaxToCart(variant.id, qty);
      })
      .then(function () {
        button.textContent = 'שודרג ל־HeroPack MAX ✓ עוברים לתשלום...';
        hideReturnToCartButton();
        setTimeout(function () {
          window.location.href = '/checkout';
        }, 650);
      })
      .catch(function () {
        button.disabled = false;
        button.dataset.loading = '0';
        button.textContent = 'לא הצליח, נסו שוב';
      });
  }

  function renderUpsell(cart, maxVariant) {
    if (!isMobile()) return;

    var drawer = getDrawer();
    if (!drawer) return;

    var footer =
      drawer.querySelector('.drawer__footer') ||
      drawer.querySelector('.cart-drawer__footer');

    if (!footer) return;

    var regular = findRegularItem(cart);
    var hasMax = hasMaxItem(cart);
    var existing = drawer.querySelector('.hp-cart-max-upsell');

    if (!regular || hasMax) {
      if (existing) existing.remove();
      return;
    }

    var card = existing || document.createElement('div');
    card.className = 'hp-cart-max-upsell';

    var data = buildUpsellHtml(regular, cart, maxVariant);

    if (card.dataset.hpSig !== data.signature) {
      card.dataset.hpSig = data.signature;
      card.innerHTML = data.html;
    }

    var btn = card.querySelector('.hp-cart-max-upsell__btn');
    if (btn && btn.dataset.hpBound !== '1') {
      btn.dataset.hpBound = '1';
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        upgradeToMax(btn);
      }, true);
    }

    var sectionLink = card.querySelector('.hp-cart-max-upsell__section-link');
    if (sectionLink && sectionLink.dataset.hpBound !== '1') {
      sectionLink.dataset.hpBound = '1';
      sectionLink.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        forceCloseDrawer();

        window.setTimeout(function () {
          scrollToMaxDetailsSection();
          showReturnToCartButton();
        }, 260);
      }, true);
    }

    var itemsArea =
      drawer.querySelector('cart-drawer-items') ||
      drawer.querySelector('#CartDrawer-CartItems');

    if (itemsArea && itemsArea.parentNode) {
      if (card.previousElementSibling !== itemsArea) {
        itemsArea.insertAdjacentElement('afterend', card);
      }
    } else if (!existing) {
      footer.insertBefore(card, footer.firstChild);
    }
  }

  function refreshUpsell() {
    if (!isMobile()) return;

    bindCloseFallback();

    getCart()
      .then(function (cart) {
        return getMaxVariant()
          .then(function (variant) {
            renderUpsell(cart, variant);
          })
          .catch(function () {
            renderUpsell(cart, { price: MAX_FALLBACK_PRICE });
          });
      })
      .catch(function () {});
  }

  function scheduleRefresh(delay) {
    if (!isMobile()) return;

    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refreshUpsell, delay || 250);
  }

  function startObserver() {
    if (observerStarted) return;
    observerStarted = true;

    var root = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer') || document.body;
    if (!root) return;

    new MutationObserver(function () {
      scheduleRefresh(350);
    }).observe(root, {
      childList: true,
      subtree: true
    });
  }

  function cleanMobileDrawerScrollLocks() {
    if (!isMobile()) return;

    var drawer = getDrawer();
    if (!drawer) return;

    var inner = drawer.querySelector('.drawer__inner');
    if (inner) {
      inner.style.setProperty('overflow-y', 'auto', 'important');
      inner.style.setProperty('overflow-x', 'hidden', 'important');
      inner.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
      inner.style.setProperty('overscroll-behavior', 'contain', 'important');
      inner.style.setProperty('touch-action', 'pan-y', 'important');
      inner.style.setProperty('display', 'block', 'important');
    }

    drawer.querySelectorAll('.drawer__contents, form, cart-drawer-items').forEach(function (el) {
      el.style.setProperty('overflow', 'visible', 'important');
      el.style.setProperty('max-height', 'none', 'important');
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty('flex', 'none', 'important');
    });
  }

  function run() {
    injectStyle();
    bindCloseFallback();
    cleanMobileDrawerScrollLocks();
    refreshUpsell();
    startObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', function () {
    setTimeout(run, 300);
    setTimeout(run, 1000);
  });

  window.addEventListener('resize', function () {
    cleanMobileDrawerScrollLocks();
    scheduleRefresh(300);
  });

  document.addEventListener('click', function () {
    scheduleRefresh(650);
    scheduleRefresh(1300);
  }, true);

  document.addEventListener('submit', function () {
    scheduleRefresh(900);
    scheduleRefresh(1600);
  }, true);

  document.addEventListener('shopify:section:load', function () {
    setTimeout(run, 300);
  });
})();
